module.exports = __webpack_public_path__ + "img/nav_2_active.4587477f.gif";